import type { SVGProps } from "react";

/**
 * Compass icon with red north tip.
 * Based on solar:compass-big-bold, pre-split into north/south halves.
 */
export function CompassNeedleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      {/* Center ring */}
      <path
        fill="currentColor"
        d="m 11.939453,10.212891 a 1.7886892,1.7886892 0 0 0 -1.205078,3.052734 1.789864,1.789864 0 0 0 2.53125,-2.53125 1.7886892,1.7886892 0 0 0 -1.326172,-0.521484 z"
      />
      {/* South half */}
      <path
        fill="currentColor"
        d="m 5.7890625,12 c 2.8e-6,0.07078 0.00136,0.142106 0.00586,0.212891 0.037101,0.555384 0.2642817,1.082428 0.7167969,2.138671 2.1220429,4.951809 3.1823949,7.428166 4.8789066,7.751954 0.402484,0.07645 0.816265,0.07645 1.21875,0 1.69651,-0.323788 2.755739,-2.800145 4.878906,-7.751954 0.452515,-1.056243 0.679697,-1.583287 0.716797,-2.138671 0.0045,-0.07079 0.0059,-0.142107 0.0059,-0.212891 h -3.23051 A 2.9811476,2.9811476 0 0 1 9.8925781,14.107422 2.9811476,2.9811476 0 0 1 9.0175781,12 Z"
      />
      {/* North half - red */}
      <path
        fill="#e53535"
        d="m 11.797473,1.8428398 a 3.2593879,3.2593879 0 0 0 -0.40625,0.05273 c -1.696511,0.323788 -2.756863,2.798192 -4.878906,7.75 C 6.059802,10.701813 5.832621,11.23081 5.79552,11.786195 c -0.0045,0.07087 -0.0059,0.142018 -0.0059,0.212891 h 3.228516 a 2.9811476,2.9811476 0 0 1 5.089843,-2.1074222 2.9811476,2.9811476 0 0 1 0.873047,2.1074222 h 3.230469 c 2e-6,-0.07087 -0.0014,-0.142018 -0.0059,-0.212891 -0.0371,-0.555385 -0.264282,-1.084382 -0.716797,-2.1406252 -2.123729,-4.951246 -3.182957,-7.426775 -4.878906,-7.75 a 3.2593879,3.2593879 0 0 0 -0.8125,-0.05273 z"
      />
    </svg>
  );
}
